import { t } from "i18next";
import { exciseLicencesRepo } from "./exciseLicences.repo";
import {
  ExciseLicenceRequestListPayload,
  IAkcizniProizvodProps,
  IKategorijeProizvodaProps,
  IMereVelicineProps,
  ISkladisteInformacijeProps,
  IZahtevDozvole,
  IZahtevDozvoleEdit,
} from "./exciseLicences.types";

class ExciseLicencesService {
  getListaKategorijeIVrsteObveznikaZaDozvolu = () => {
    return exciseLicencesRepo.getListaKategorijeIVrsteObveznikaZaDozvolu();
  };

  getSviZahteviZaDozvolu = (payload: ExciseLicenceRequestListPayload) => {
    return exciseLicencesRepo.getSviZahteviZaDozvolu(payload);
  };

  postVracanjeDodatnihInformacijaZaKreiranjeDozvole = (
    skladisteId: number | null
  ) => {
    return exciseLicencesRepo.postVracanjeDodatnihInformacijaZaKreiranjeDozvole(
      skladisteId
    );
  };

  postKreiranjeZahtevaDozvole = (payload: IZahtevDozvole) => {
    return exciseLicencesRepo.postKreiranjeZahtevaDozvole(payload);
  };

  updateIzmenaZahtevaDozvole = (payload: IZahtevDozvoleEdit) => {
    return exciseLicencesRepo.updateIzmenaZahtevaDozvole(payload);
  };

  getTipObveznikaOptions = (
    id: number | null,
    state: IKategorijeProizvodaProps[]
  ) => {
    const options = state.find(
      (options) => options.idKategorijeProizvoda === id
    );
    return options?.tipObveznika.map((option) => {
      return { label: option.imeTipaObveznika, value: option.tipObveznikaId };
    });
  };

  getAkcizniProizvodiOptions = (options: IAkcizniProizvodProps[]) => {
    const newOptions = options.map((option: IAkcizniProizvodProps) => {
      return {
        label: option.kategorijeProizvodaIme,
        value: option.kategorijeProizvodaId,
        disabled: !option.isActive,
      };
    });
    return newOptions;
  };

  getMeraOptions = (options: IMereVelicineProps[]) => {
    if (!options) return;
    const newOptions = options.map((option: IMereVelicineProps) => {
      const latin = () => {
        if (option.meraIme === "Povrsina") return t("PLACEHOLDERS.POVRSINA");
        if (option.meraIme === "Zapremina") return t("PLACEHOLDERS.ZAPREMINA");
        return option.meraIme;
      };
      return {
        label: latin(),
        value: option.meraId,
      };
    });
    return newOptions;
  };

  getSkladistaOptions = (options: ISkladisteInformacijeProps[]) => {
    if (!options.length) return null;
    const newOptions = options.map((option: ISkladisteInformacijeProps) => {
      return {
        label: `${option.mestoSkladista} - ${option.oznakaSkladista}`,
        value: option.skladisteId,
      };
    });
    return newOptions;
  };

  filterDokumentiZaDozvolu = (dokumentiZaDozvolu: any[], docUid: string) => {
    const filesForUpload = [...dokumentiZaDozvolu];
    return filesForUpload.filter((forUpload) => forUpload.uid !== docUid);
  };
}

export const exciseLicencesService = new ExciseLicencesService();
